import { Navigate, Outlet, RouteObject } from "react-router-dom";
import MergerRoute from "./merger";
import BloctelRoute from "./bloctel";
import InvoiceCorrectionRoute from "./invoice_correction";
import SalesRoute from "./sales";
import MailingCampaignRoute from "./mailing_campaign";
import CallsRoute from "./calls/calls";
import MessageRoute from "./message";
import MetabaseRoute from "./metabase";
import VaultRoute from "./vault";
import { DiabolocomInjectionRoute } from "./flash-injection";
import SiretRoute from "./siret";
import DialerRoute from "./dialer";
import LeadRecyclingRoute from "./lead_recycling";
import DesignSystemRoute from "./design-system";

const ToolRoute: RouteObject = {
    path: "outils",
    element: <Outlet />,
    children: [
        {
            index: true,
            element: <Navigate to="/outils/fusion" replace />
        },
        MergerRoute,
        BloctelRoute,
        InvoiceCorrectionRoute,
        SalesRoute,
        MailingCampaignRoute,
        CallsRoute,
        DialerRoute,
        MessageRoute,
        MetabaseRoute,
        VaultRoute,
        DiabolocomInjectionRoute,
        MessageRoute,
        SiretRoute,
        LeadRecyclingRoute,
        DesignSystemRoute
    ]
};
export default ToolRoute;
